import { useCallback, useState } from 'react';
import { auth } from '../../API/resources/GisRoAuth';

interface RenderErrorProps {
  error: string;
  reload(): void;
}

interface EsiaInitializerProps {
  onSuccess?(link: string): void;
  onError?(error: string): void;
  renderFallback(load: () => void): JSX.Element;
  renderLoading(): JSX.Element;
  renderError({ error, reload }: RenderErrorProps): JSX.Element;
}

/** Отвечает за рендер интерфейса, который зависим от ссылки на форму аутентификации Госуслуг. */
export const EsiaInitializer = ({
  onError,
  onSuccess,
  renderFallback,
  renderLoading,
  renderError,
}: EsiaInitializerProps) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  const fetchEsiaLoginPage = useCallback(async () => {
    try {
      setIsLoading(true);
      setError(undefined);

      const link = await auth.getEsiaLoginForm();

      if (onSuccess) onSuccess(link);
    } catch (e) {
      const message =
        e instanceof Error
          ? e.message
          : 'Не удалось авторизоваться через Госуслуги';

      setError(message);

      if (onError) onError(message);
    } finally {
      setIsLoading(false);
    }
  }, [setIsLoading, setError]);

  if (isLoading) return renderLoading();

  if (error) return renderError({ error, reload: fetchEsiaLoginPage });

  return renderFallback(fetchEsiaLoginPage);
};
